export default __webpack_public_path__ + "static/media/cheatday@2x.85ccdf22.jpg";